/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const searchPatients = /* GraphQL */ `
  query SearchPatients($input: AWSJSON) {
    searchPatients(input: $input)
  }
`;
export const queryNumerics = /* GraphQL */ `
  query QueryNumerics($input: AWSJSON) {
    queryNumerics(input: $input)
  }
`;
export const write = /* GraphQL */ `
  query Write($input: AWSJSON) {
    write(input: $input)
  }
`;
export const fetchSyncFhir = /* GraphQL */ `
  query FetchSyncFhir($input: AWSJSON) {
    fetchSyncFhir(input: $input)
  }
`;
export const generativeCohortAi = /* GraphQL */ `
  query GenerativeCohortAi($input: AWSJSON) {
    generativeCohortAI(input: $input)
  }
`;
export const generativeSqlai = /* GraphQL */ `
  query GenerativeSqlai($input: String!) {
    generativeSQLAI(input: $input)
  }
`;
export const dispoPrediction = /* GraphQL */ `
  query DispoPrediction($input: String!) {
    dispoPrediction(input: $input)
  }
`;
export const riskScore = /* GraphQL */ `
  query RiskScore($input: String!) {
    riskScore(input: $input)
  }
`;
export const queryInference = /* GraphQL */ `
  query QueryInference($input: AWSJSON) {
    queryInference(input: $input)
  }
`;
export const calculateVitalsAbnormalities = /* GraphQL */ `
  query CalculateVitalsAbnormalities($input: AWSJSON) {
    calculateVitalsAbnormalities(input: $input)
  }
`;
export const dashboardLlmAbnormalities = /* GraphQL */ `
  query DashboardLlmAbnormalities($input: AWSJSON) {
    dashboardLLMAbnormalities(input: $input)
  }
`;
export const getBatchInfo = /* GraphQL */ `
  query GetBatchInfo($csn: String!, $batchStart: Int!) {
    getBatchInfo(csn: $csn, batchStart: $batchStart) {
      csn
      mrn
      batch_start
      batch_end
      batch_length
      identifier
      batch_status
      waveform_modalities
    }
  }
`;
